import { combineReducers } from "redux";
import paneList from "./paneList";

export default combineReducers({
  paneList
});
